import * as React from 'react';

import {providers} from '@logilab/cwclientlibjs';
import {EntityTypeListElem} from './EntityType';
import {filterWithTextSearch} from './SearchBar';
import {compareNamedEntities} from '../commons';

interface EntityTypesListProps {
    entities: providers.EntitySchema[];
    selectedEntityTypeName: string | null;
    selectEntityType: (entityName: string) => void;
    tempSelectedEntityTypeName: string | null;
    setTempEntityTypeName: (entityName: string | null) => void;
    deselectTempEntityType: () => void;
    textSearch: string;
}

export class EntityTypesList extends React.Component<EntityTypesListProps> {
    static defaultProps = {
        tempSelectedEntityTypeName: null,
        setTempEntityTypeName: () => {},
        deselectTempEntityType: () => {},
    };
    constructor(props: Readonly<EntityTypesListProps>) {
        super(props);
        this.state = {textSearch: ''};
    }

    private renderEntityTypeList(): JSX.Element {
        const filteredEntityTypes = filterWithTextSearch(
            this.props.textSearch,
            this.props.entities
        ).sort(compareNamedEntities);

        return filteredEntityTypes.length > 0 ? (
            <ul>
                {filteredEntityTypes.map((entityType) => (
                    <li
                        key={entityType.eid}
                        onMouseOver={() =>
                            this.props.setTempEntityTypeName(entityType.name)
                        }
                        onMouseOut={() => {
                            this.props.deselectTempEntityType();
                        }}
                        onClick={() => {
                            this.props.selectEntityType(entityType.name);
                        }}
                        className={
                            this.props.selectedEntityTypeName !== null &&
                            entityType.name ===
                                this.props.selectedEntityTypeName
                                ? 'selected'
                                : ''
                        }
                    >
                        <EntityTypeListElem entityType={entityType} />
                    </li>
                ))}
            </ul>
        ) : (
            <></>
        );
    }

    render() {
        return (
            <div className="column-content">
                <div className="entity-types">
                    {this.renderEntityTypeList()}
                </div>
                {this.props.children}
            </div>
        );
    }
}
